import React from 'react';
import { useSelector } from 'react-redux';

import { SkeletonTable } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const Products = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  if (StateLoading) {
    return <SkeletonTable headerCount={5} bodyCount={5} />;
  }

  return (
    <div>
      <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
        Informasi Product
      </div>
      <div className="table-responsive m-0">
        <table
          width="100%"
          className="table table-hover table-vcenter card-table datatable border"
        >
          <thead className="bg-light">
            <tr className="th">
              <td style={{ whiteSpace: 'initial', width: '500px' }}>
                Services
              </td>
              <td style={{ whiteSpace: 'initial', width: '120px' }}>
                Quantity
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '120px',
                  textAlign: 'end',
                }}
              >
                Unit Price
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '120px',
                  textAlign: 'end',
                }}
              >
                Discount
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '50px',
                  textAlign: 'center',
                }}
              >
                TAX
              </td>
              <td
                style={{
                  whiteSpace: 'initial',
                  width: '120px',
                  textAlign: 'end',
                }}
              >
                Subtotal
              </td>
            </tr>
          </thead>
          <tbody>
            {data?.products?.map((s, i) => (
              <tr key={i}>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  <div className="table-col">
                    <div className="text-ellipsis text-uppercase">
                      {s?.product?.name}
                    </div>
                    <small className="info text-uppercase">
                      {s?.description}
                    </small>
                  </div>
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px' }}>
                  {currencyFormat(s?.quantity)} {s?.unit?.unit}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '120px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.unit_price)}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '120px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.discount)}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '120px',
                    textAlign: 'center',
                  }}
                >
                  {s?.tax?.text}
                </td>
                <td
                  style={{
                    whiteSpace: 'initial',
                    width: '100px',
                    textAlign: 'end',
                  }}
                >
                  {currencyFormat(s?.unit_nett)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
